import { Card, Col, Row, message, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import StatisticWidget from "components/shared-components/StatisticWidget";
import { useDispatch } from "react-redux";
import { fetchAllProjectsBermasalah, fetchProjectSummary } from "redux/features/projects";
import { fetchAllProjects, fetchRankingCompany } from "redux/features/projects";
import { getUserProfile } from "redux/features/auth";
import { PROJECTS } from "../projects";
import Map from "../../../components/Maps";
import { MYPROJECTS } from "../my-projects";
import { fetchAllUser } from "redux/features/user";
import MyProjectsBa from "../projects-dalam-pengawasan";

let IDRFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'IDR',
});

export const DefaultDashboard = () => {
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [totalProjects, setTotalProjects] = useState(<Spin></Spin>);
  const [myProjects, setMyProjects] = useState(<Spin></Spin>);
  const [allProjects, setAllProjects] = useState([]);
  const [kdkmpBeroperasi, setKDKMPBeroperasi] = useState(<Spin></Spin>);
  const [kdkmpPermohonan, setKDKMPPermohonan] = useState(<Spin></Spin>);
  const [kdkmpBermasalah, setKDKMPBermasalah] = useState([]);
  const [perusahaan, setPerusahaan] = useState(0);
  const [OPD, setOPD] = useState(0);
  const [ranking, setRanking] = useState(0);
  const [kdkmpBelumAktif, setKDKMPBelumAktif] = useState(0);
  const [kdkmpBA, setKDKMPBA] = useState(0);
  const [isLoading, setLoading] = useState(true);
  const [ba, setTotalBa] = useState(<Spin></Spin>);
  const [role, setRole] = useState(0);
  const [company, setCompany] = useState("");
  const [kabupaten, setKabupaten] = useState("");

  const getAllDashboardData = async (params) => {
    try {
      const response = await dispatch(getUserProfile()).unwrap();
      const summary = await dispatch(fetchProjectSummary()).unwrap();
      const ba = await dispatch(fetchAllUser({ role_id: 3, kabupaten: response.data.user.kabupaten, limit:100, id_pmo:response.data.user.username })).unwrap();
      const kdkmpBeroperasi = await dispatch(fetchProjectSummary({ status: "BEROPERASI", kabupaten: response.data.user.kabupaten })).unwrap();
      const kdkmpBermasalah = await dispatch(fetchAllProjectsBermasalah()).unwrap();
      const mySummary = await dispatch(fetchProjectSummary({ kabupaten: response.data.user.kabupaten })).unwrap();
      const kdkmpBA = await dispatch(fetchProjectSummary({ id_ba: response.data.user.username })).unwrap();

      setMyProjects(mySummary.data.totalProjects)
      setKDKMPBeroperasi(kdkmpBeroperasi.data.totalProjects)
      setKDKMPPermohonan(mySummary.data.totalProjects)
      setKDKMPBermasalah(kdkmpBermasalah.data.Projects)
      setTotalProjects(summary.data.totalProjects)
      setKDKMPBelumAktif(summary.data.totalProjects - kdkmpBeroperasi.data.totalProjects)
      setKDKMPBA(kdkmpBA.data)
      setTotalBa(ba.data)
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const getData = async () => {
    try {
      const response = await dispatch(fetchAllProjects({
        limit: 5000
      })).unwrap();
      console.log({
        projects: response.data.Projects
      })
      setAllProjects(response.data.Projects)
      setLoading(false);
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  }

  const getCompanyRanking = async () => {
    try {
      const perusahaan = await dispatch(getUserProfile()).unwrap();
      const response = await dispatch(fetchRankingCompany({
        perusahaan: perusahaan.data.user.perusahaan
      })).unwrap();
      setUsername(perusahaan.data.user.username)
      setPerusahaan(perusahaan.data.user.perusahaan)
      setRanking(response.data[0]?.rank || 0)
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  }

  const getProfile = async () => {
    try {
      const response = await dispatch(getUserProfile()).unwrap();
      setRole(response.data.user.role_id)
      setCompany(response.data.user.perusahaan)
      setKabupaten(response.data.user.kabupaten)
      setOPD(response.data.user.opd)
      getData();
    } catch (error) {
      setLoading(false);
      message.error(error?.message || "Failed to fetch data");
    }
  };

  useEffect(() => {
    getProfile()
    getAllDashboardData()
    getCompanyRanking()
  }, []);

  return (
    <>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <h2>Selamat Datang {username}</h2>

          <h4>Kabupaten/Kota {kabupaten}</h4>
          <p>
            Jika menemukan bug ataupun error pada aplikasi ini bisa langsung hubungi kami di <a target="_blank" href="https://wa.me/6285899731884">085899731884</a>
          </p>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Row gutter={24}>
            {/* {role === 2 && (
              <Col xs={24} sm={24} md={24} lg={12} xl={12} key={1}>
                <StatisticWidget
                  style={{ textAlign: "center" }}
                  title={`Peringkat Kinerja Anda`}
                  value={ranking === 0 ? <div style={{ color: "red" }}>{"Belum Berpartisipasi"}</div> : ranking}
                />
              </Col>
            )} */}
            {role === 1 && (
              <Col xs={24} sm={24} md={24} lg={8} xl={8} key={3}>
                <StatisticWidget
                  style={{ textAlign: "center" }}
                  title={`Total Semua KDKMP`}
                  value={totalProjects ? totalProjects : <Spin></Spin>}
                />
              </Col>)}
            {(role === 2 || role === 1) && (
              <Col xs={24} sm={24} md={24} lg={8} xl={8} key={4}>
                <StatisticWidget
                  style={{ textAlign: "center" }}
                  title={`Total Semua KDKMP`}
                  value={myProjects ? myProjects : <Spin></Spin>}
                />
              </Col>)}
            {(role === 3) && (
              <Col xs={24} sm={24} md={24} lg={8} xl={8} key={4}>
                <StatisticWidget
                  style={{ textAlign: "center" }}
                  title={`Total Semua KDKMP`}
                  value={myProjects ? myProjects : <Spin></Spin>}
                />
              </Col>)}
            {(role === 2 || role === 1 || role === 3) && (
              <Col xs={24} sm={24} md={24} lg={8} xl={8} key={5}>
                <StatisticWidget
                  style={{ textAlign: "center" }}
                  title={`KDKMP Beroperasi`}
                  value={(kdkmpBeroperasi || kdkmpBeroperasi === 0) ? kdkmpBeroperasi : <Spin></Spin>}
                />
              </Col>)}
            {(role === 2 || role === 1 || role === 3) && (
              <Col xs={24} sm={24} md={24} lg={8} xl={8} key={6}>
                <StatisticWidget
                  style={{ textAlign: "center" }}
                  title={`KDKMP Bermasalah`}
                  value={(kdkmpBermasalah.length || kdkmpBermasalah.length === 0) ? kdkmpBermasalah.length : <Spin></Spin>}
                />
              </Col>
            )}
            {(role === 2 || role === 1) && (
              <Col xs={24} sm={24} md={24} lg={8} xl={8} key={7}>
                <StatisticWidget
                  style={{ textAlign: "center" }}
                  title={`Total BA Aktif`}
                  value={ba.length ? ba.length : <Spin></Spin>}
                />
              </Col>)}
            {(role === 1) && (
              <Col xs={24} sm={24} md={24} lg={8} xl={8} key={8}>
                <StatisticWidget
                  style={{ textAlign: "center" }}
                  title={`Total KDKMP Belum Aktif`}
                  value={myProjects - kdkmpBeroperasi}
                />
              </Col>
            )}
            {role === 2 && (
              <Col xs={24} sm={24} md={24} lg={8} xl={8} key={9}>
                <StatisticWidget
                  style={{ textAlign: "center" }}
                  title={`Total KDKMP Belum Aktif`}
                  value={myProjects - kdkmpBeroperasi}
                />
              </Col>
            )}

            {role === 1 && (
              <Col xs={24} sm={24} md={24} lg={8} xl={8} key={11}>
                <StatisticWidget
                  style={{ textAlign: "center" }}
                  title={`Progress KDKMP Beroperasi`}
                  value={<div style={{ color: ((kdkmpBeroperasi / totalProjects) * 100).toFixed(2) < 50 ? 'red' : 'green' }}>{`${(kdkmpBeroperasi / totalProjects * 100).toFixed(2)}%`}</div>}
                />
              </Col>)}
            {role === 2 && (
              <Col xs={24} sm={24} md={24} lg={8} xl={8} key={12}>
                <StatisticWidget
                  style={{ textAlign: "center" }}
                  title={`Progress KDKMP Beroperasi`}
                  value={<div style={{ color: ((kdkmpBeroperasi / myProjects) * 100).toFixed(2) < 50 ? 'red' : 'green' }}>{`${(kdkmpBeroperasi / myProjects * 100).toFixed(2)}%`}</div>}
                />
              </Col>)}

          </Row>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Card>
                <Map projects={allProjects}></Map>
              </Card>
            </Col>
          </Row>
          {role === 1 && (
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <PROJECTS></PROJECTS>
              </Col>
            </Row>
          )}
          {role === 2 && (
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <MYPROJECTS></MYPROJECTS>
              </Col>
            </Row>
          )}
          {role === 4 && (
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <PROJECTS></PROJECTS>
              </Col>
            </Row>
          )}
          {role === 3 && (
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <MyProjectsBa></MyProjectsBa>
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </>
  );
};

export default withRouter(DefaultDashboard);
